import * as React from 'react'

import * as plume from '@ulule/owl-kit-components/next'

export function useDebouncedState<T>(initialValue: T, callback: (value: T) => void): [T, (value: T) => void] {
  const [searchValue, setSearchValue] = React.useState<T>(initialValue)
  const debouncedSearch = plume.hooks.useDebounce((value: T) => callback(value), false)

  return [
    searchValue,
    (value: T) => {
      setSearchValue(value)
      debouncedSearch(value)
    },
  ]
}
